import React from "react";

const SectionTitle = ({ text, color }) => {
  return (
    <div className="section-title" style={{ borderColor: color }}>
      <span style={{ backgroundColor: color }}>{text}</span>
    </div>
  );
};

export default SectionTitle;
